import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

function Section({ title, children }) {
  return (
    <section className="mt-8">
      <h2 className="font-heading font-bold text-xl text-brand-graphite mb-3">{title}</h2>
      <div className="text-sm text-brand-graphite/80 leading-relaxed space-y-2">{children}</div>
    </section>
  );
}

export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-12" data-testid="privacy-page">
      <span className="inline-flex items-center gap-2 bg-brand-mintLight text-brand-mintDark text-xs font-semibold px-3 py-1.5 rounded-full mb-5">
        <ShieldCheck className="w-3.5 h-3.5" /> Documento legal
      </span>
      <h1 className="text-3xl sm:text-4xl font-bold font-heading text-brand-graphite">Política de Privacidade</h1>
      <p className="text-sm text-muted-foreground mt-2">PetMachine Hub — petmachinehub.com.br · Última atualização: setembro de 2026</p>

      <Section title="1. Quem somos (controlador dos dados)">
        <p>O PetMachine Hub é operado por <strong>PET MACHINE LTDA</strong>, CNPJ 52.426.405/0001-90, com atuação em Joinville/SC. Para esta Política, somos o "controlador" dos seus dados pessoais, nos termos da Lei Geral de Proteção de Dados (Lei nº 13.709/2018 — LGPD).</p>
        <p>Contato do encarregado de dados (DPO): <strong>petmachineltda@gmail.com</strong></p>
      </Section>

      <Section title="2. Quais dados coletamos">
        <ul className="list-disc pl-5 space-y-1.5">
          <li><strong>Cadastro:</strong> nome, e-mail, telefone, cidade e endereço para entregas.</li>
          <li><strong>Dados dos pets:</strong> nome, espécie, raça, foto, carteira de vacinação, alergias e códigos de identificação (tags/anilhas) que você cadastrar.</li>
          <li><strong>Pagamentos:</strong> processados integralmente pelo Mercado Pago — não armazenamos números de cartão.</li>
          <li><strong>Conteúdo comunitário:</strong> relatos de avistamento e mensagens de "pet encontrado" que você enviar.</li>
          <li><strong>Uso da plataforma:</strong> registros de pedidos, assinaturas e interações necessários à operação do serviço.</li>
        </ul>
      </Section>

      <Section title="3. Para que usamos (finalidades e bases legais)">
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Executar o serviço contratado: carteira digital, identificação de pets, pedidos e entregas (execução de contrato);</li>
          <li>Reunir pets perdidos aos tutores, exibindo apenas o que você escolher tornar público (consentimento);</li>
          <li>Cumprir obrigações fiscais e contábeis das vendas (obrigação legal);</li>
          <li>Melhorar a plataforma e prevenir fraudes (legítimo interesse).</li>
        </ul>
      </Section>

      <Section title="4. Compartilhamento">
        <p>Compartilhamos dados apenas com operadores essenciais: <strong>Mercado Pago</strong> (pagamentos), provedor de autenticação Google (quando você opta pelo login social) e infraestrutura de nuvem que hospeda a aplicação. Não vendemos dados pessoais. Prestadores parceiros só recebem seu contato quando você inicia o atendimento com eles.</p>
      </Section>

      <Section title="5. Páginas públicas de tags e anilhas">
        <p>Cada tag/anilha possui uma página pública (ex.: /tag/código) para quem encontrar seu pet. Você controla o que aparece nela; o telefone de contato exibido é o que você cadastrou para a gravação. Ao marcar um pet como desaparecido, a página passa a exibir o aviso e o canal "Encontrei este pet".</p>
      </Section>

      <Section title="6. Cookies e sessão">
        <p>Usamos apenas cookies/sessão estritamente necessários para manter seu login e funcionamento da conta. Não usamos cookies de publicidade de terceiros.</p>
      </Section>

      <Section title="7. Seus direitos (LGPD)">
        <p>Você pode, a qualquer momento: confirmar e acessar seus dados, corrigi-los na aba "Minha Conta" da área do cliente, solicitar a portabilidade, revogar consentimentos e <strong>excluir sua conta e dados</strong> entrando em contato pelo e-mail abaixo. Pedidos de exclusão são atendidos em até 15 dias, ressalvadas as obrigações legais de retenção (ex.: registros fiscais de vendas).</p>
      </Section>

      <Section title="8. Retenção e segurança">
        <p>Guardamos os dados enquanto sua conta estiver ativa ou pelo período exigido por lei. Aplicamos criptografia em trânsito (HTTPS), controle de acesso por perfil e validação de assinatura nas notificações de pagamento.</p>
      </Section>

      <Section title="9. Menores de idade">
        <p>A plataforma é destinada a maiores de 18 anos. Contas de menores devem ser criadas e gerenciadas por um responsável legal.</p>
      </Section>

      <Section title="10. Alterações desta política">
        <p>Podemos atualizar este documento; a versão vigente estará sempre disponível em <strong>petmachinehub.com.br/privacidade</strong> com a data de atualização. Mudanças relevantes serão avisadas dentro do aplicativo.</p>
      </Section>

      <Section title="11. Contato">
        <p>Dúvidas, solicitações de titulares ou contato da autoridade: <strong>petmachineltda@gmail.com</strong> · Joinville/SC, Brasil.</p>
      </Section>

      <div className="mt-10 bg-brand-cream rounded-2xl p-5 text-center">
        <Link to="/" data-testid="privacy-back-home" className="text-brand-coral font-semibold text-sm hover:underline">← Voltar para a página inicial</Link>
      </div>
    </div>
  );
}
